// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.6
// source: events/so5/shared/events.proto

/* eslint-disable */
import { Sport, sportFromJSON, sportToJSON } from '../../shared/events';

export const protobufPackage = 'events.so5.shared';

export interface LoginUser {
  method: LoginUser_Method;
  failed: boolean;
}

export enum LoginUser_Method {
  EMAIL = 0,
  GOOGLE = 1,
  FACEBOOK = 2,
  APPLE = 3,
  UNRECOGNIZED = -1,
}

export function loginUser_MethodFromJSON(object: any): LoginUser_Method {
  switch (object) {
    case 0:
    case 'EMAIL':
      return LoginUser_Method.EMAIL;
    case 1:
    case 'GOOGLE':
      return LoginUser_Method.GOOGLE;
    case 2:
    case 'FACEBOOK':
      return LoginUser_Method.FACEBOOK;
    case 3:
    case 'APPLE':
      return LoginUser_Method.APPLE;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return LoginUser_Method.UNRECOGNIZED;
  }
}

export function loginUser_MethodToJSON(object: LoginUser_Method): string {
  switch (object) {
    case LoginUser_Method.EMAIL:
      return 'EMAIL';
    case LoginUser_Method.GOOGLE:
      return 'GOOGLE';
    case LoginUser_Method.FACEBOOK:
      return 'FACEBOOK';
    case LoginUser_Method.APPLE:
      return 'APPLE';
    case LoginUser_Method.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface LogoutUser {}

export interface ClickInstantBuy {
  offerId: string;
  cardSlug: string;
  ethAmount?: number | undefined;
  eurAmount: number;
  gameSlug?: string | undefined;
  origin: ClickInstantBuy_Flow;
  sport: Sport;
  scarcity: string;
  composeSessionId: string;
  rosterId?: string | undefined;
}

export enum ClickInstantBuy_Flow {
  PRE_MATCH = 0,
  LINEUP_UPGRADE = 1,
  MAN_MATCH = 2,
  MATCH_VIEW = 3,
  MARKETPLACE = 4,
  CUSTOM_LEAGUE_ONBOARDING = 5,
  COMPOSE_BUY = 6,
  FOR_YOU = 7,
  SCOUTING_CENTER = 8,
  COLLECTION = 9,
  MATCH_CENTER = 10,
  CARD_PAGE = 11,
  LOAN_FLOW = 12,
  TOP_PLAYERS = 13,
  QUICK_PLAY = 14,
  MARKETPLACE_HOME = 15,
  UNRECOGNIZED = -1,
}

export function clickInstantBuy_FlowFromJSON(
  object: any
): ClickInstantBuy_Flow {
  switch (object) {
    case 0:
    case 'PRE_MATCH':
      return ClickInstantBuy_Flow.PRE_MATCH;
    case 1:
    case 'LINEUP_UPGRADE':
      return ClickInstantBuy_Flow.LINEUP_UPGRADE;
    case 2:
    case 'MAN_MATCH':
      return ClickInstantBuy_Flow.MAN_MATCH;
    case 3:
    case 'MATCH_VIEW':
      return ClickInstantBuy_Flow.MATCH_VIEW;
    case 4:
    case 'MARKETPLACE':
      return ClickInstantBuy_Flow.MARKETPLACE;
    case 5:
    case 'CUSTOM_LEAGUE_ONBOARDING':
      return ClickInstantBuy_Flow.CUSTOM_LEAGUE_ONBOARDING;
    case 6:
    case 'COMPOSE_BUY':
      return ClickInstantBuy_Flow.COMPOSE_BUY;
    case 7:
    case 'FOR_YOU':
      return ClickInstantBuy_Flow.FOR_YOU;
    case 8:
    case 'SCOUTING_CENTER':
      return ClickInstantBuy_Flow.SCOUTING_CENTER;
    case 9:
    case 'COLLECTION':
      return ClickInstantBuy_Flow.COLLECTION;
    case 10:
    case 'MATCH_CENTER':
      return ClickInstantBuy_Flow.MATCH_CENTER;
    case 11:
    case 'CARD_PAGE':
      return ClickInstantBuy_Flow.CARD_PAGE;
    case 12:
    case 'LOAN_FLOW':
      return ClickInstantBuy_Flow.LOAN_FLOW;
    case 13:
    case 'TOP_PLAYERS':
      return ClickInstantBuy_Flow.TOP_PLAYERS;
    case 14:
    case 'QUICK_PLAY':
      return ClickInstantBuy_Flow.QUICK_PLAY;
    case 15:
    case 'MARKETPLACE_HOME':
      return ClickInstantBuy_Flow.MARKETPLACE_HOME;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ClickInstantBuy_Flow.UNRECOGNIZED;
  }
}

export function clickInstantBuy_FlowToJSON(
  object: ClickInstantBuy_Flow
): string {
  switch (object) {
    case ClickInstantBuy_Flow.PRE_MATCH:
      return 'PRE_MATCH';
    case ClickInstantBuy_Flow.LINEUP_UPGRADE:
      return 'LINEUP_UPGRADE';
    case ClickInstantBuy_Flow.MAN_MATCH:
      return 'MAN_MATCH';
    case ClickInstantBuy_Flow.MATCH_VIEW:
      return 'MATCH_VIEW';
    case ClickInstantBuy_Flow.MARKETPLACE:
      return 'MARKETPLACE';
    case ClickInstantBuy_Flow.CUSTOM_LEAGUE_ONBOARDING:
      return 'CUSTOM_LEAGUE_ONBOARDING';
    case ClickInstantBuy_Flow.COMPOSE_BUY:
      return 'COMPOSE_BUY';
    case ClickInstantBuy_Flow.FOR_YOU:
      return 'FOR_YOU';
    case ClickInstantBuy_Flow.SCOUTING_CENTER:
      return 'SCOUTING_CENTER';
    case ClickInstantBuy_Flow.COLLECTION:
      return 'COLLECTION';
    case ClickInstantBuy_Flow.MATCH_CENTER:
      return 'MATCH_CENTER';
    case ClickInstantBuy_Flow.CARD_PAGE:
      return 'CARD_PAGE';
    case ClickInstantBuy_Flow.LOAN_FLOW:
      return 'LOAN_FLOW';
    case ClickInstantBuy_Flow.TOP_PLAYERS:
      return 'TOP_PLAYERS';
    case ClickInstantBuy_Flow.QUICK_PLAY:
      return 'QUICK_PLAY';
    case ClickInstantBuy_Flow.MARKETPLACE_HOME:
      return 'MARKETPLACE_HOME';
    case ClickInstantBuy_Flow.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface ClickBuyInAppPurchase {
  offerId: string;
  cardSlug: string;
  ethAmount?: number | undefined;
  eurAmount: number;
  gameSlug?: string | undefined;
  sport: Sport;
}

export interface ClickBuyGemsPack {
  packId: string;
  sport: Sport;
}

export interface ClickPreMatchUpsell {
  gameSlug: string;
  cardSlugs: string[];
  sport: Sport;
}

export interface ClickAfterPurchase {
  offerId: string;
  cardSlug: string;
  gameSlug?: string | undefined;
  sport: Sport;
  action: ClickAfterPurchase_Action;
}

export enum ClickAfterPurchase_Action {
  BUY_MORE = 0,
  SET_MY_LINEUP = 1,
  SEE_MY_CARDS = 2,
  BACK_TO_LIVE_FEED = 3,
  CONTINUE = 4,
  PLAY_PRO = 5,
  UNRECOGNIZED = -1,
}

export function clickAfterPurchase_ActionFromJSON(
  object: any
): ClickAfterPurchase_Action {
  switch (object) {
    case 0:
    case 'BUY_MORE':
      return ClickAfterPurchase_Action.BUY_MORE;
    case 1:
    case 'SET_MY_LINEUP':
      return ClickAfterPurchase_Action.SET_MY_LINEUP;
    case 2:
    case 'SEE_MY_CARDS':
      return ClickAfterPurchase_Action.SEE_MY_CARDS;
    case 3:
    case 'BACK_TO_LIVE_FEED':
      return ClickAfterPurchase_Action.BACK_TO_LIVE_FEED;
    case 4:
    case 'CONTINUE':
      return ClickAfterPurchase_Action.CONTINUE;
    case 5:
    case 'PLAY_PRO':
      return ClickAfterPurchase_Action.PLAY_PRO;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ClickAfterPurchase_Action.UNRECOGNIZED;
  }
}

export function clickAfterPurchase_ActionToJSON(
  object: ClickAfterPurchase_Action
): string {
  switch (object) {
    case ClickAfterPurchase_Action.BUY_MORE:
      return 'BUY_MORE';
    case ClickAfterPurchase_Action.SET_MY_LINEUP:
      return 'SET_MY_LINEUP';
    case ClickAfterPurchase_Action.SEE_MY_CARDS:
      return 'SEE_MY_CARDS';
    case ClickAfterPurchase_Action.BACK_TO_LIVE_FEED:
      return 'BACK_TO_LIVE_FEED';
    case ClickAfterPurchase_Action.CONTINUE:
      return 'CONTINUE';
    case ClickAfterPurchase_Action.PLAY_PRO:
      return 'PLAY_PRO';
    case ClickAfterPurchase_Action.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface ClickAfterLineupUpgradePurchase {
  gameSlug: string;
  lineupId: string;
  action: ClickAfterLineupUpgradePurchase_Action;
  sport: Sport;
}

export enum ClickAfterLineupUpgradePurchase_Action {
  BUY_MORE = 0,
  CONFIRM_LINEUP = 1,
  UNRECOGNIZED = -1,
}

export function clickAfterLineupUpgradePurchase_ActionFromJSON(
  object: any
): ClickAfterLineupUpgradePurchase_Action {
  switch (object) {
    case 0:
    case 'BUY_MORE':
      return ClickAfterLineupUpgradePurchase_Action.BUY_MORE;
    case 1:
    case 'CONFIRM_LINEUP':
      return ClickAfterLineupUpgradePurchase_Action.CONFIRM_LINEUP;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ClickAfterLineupUpgradePurchase_Action.UNRECOGNIZED;
  }
}

export function clickAfterLineupUpgradePurchase_ActionToJSON(
  object: ClickAfterLineupUpgradePurchase_Action
): string {
  switch (object) {
    case ClickAfterLineupUpgradePurchase_Action.BUY_MORE:
      return 'BUY_MORE';
    case ClickAfterLineupUpgradePurchase_Action.CONFIRM_LINEUP:
      return 'CONFIRM_LINEUP';
    case ClickAfterLineupUpgradePurchase_Action.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface ClickContinueWithoutUpgrade {
  gameSlug: string;
  lineupId: string;
  sport: Sport;
}

export interface DisplayUpgradeLineup {
  gameSlug: string;
  lineupId: string;
  sport: Sport;
}

export interface ClickBoostRivalsLineup {
  interactionContext: string;
  gameSlug: string;
  lineupId: string;
  sport: Sport;
}

export interface OpenRewardBox {
  sport: Sport;
  rewardBoxId: string;
}

export interface ViewRivalsLeaguesTutorial {
  step: number;
  source: ViewRivalsLeaguesTutorial_Source;
}

export enum ViewRivalsLeaguesTutorial_Source {
  ACTIVITY_FEED = 0,
  CREATION_FLOW = 1,
  UNRECOGNIZED = -1,
}

export function viewRivalsLeaguesTutorial_SourceFromJSON(
  object: any
): ViewRivalsLeaguesTutorial_Source {
  switch (object) {
    case 0:
    case 'ACTIVITY_FEED':
      return ViewRivalsLeaguesTutorial_Source.ACTIVITY_FEED;
    case 1:
    case 'CREATION_FLOW':
      return ViewRivalsLeaguesTutorial_Source.CREATION_FLOW;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ViewRivalsLeaguesTutorial_Source.UNRECOGNIZED;
  }
}

export function viewRivalsLeaguesTutorial_SourceToJSON(
  object: ViewRivalsLeaguesTutorial_Source
): string {
  switch (object) {
    case ViewRivalsLeaguesTutorial_Source.ACTIVITY_FEED:
      return 'ACTIVITY_FEED';
    case ViewRivalsLeaguesTutorial_Source.CREATION_FLOW:
      return 'CREATION_FLOW';
    case ViewRivalsLeaguesTutorial_Source.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface RivalsLeagueCreated {
  slug: string;
}

export interface RivalsLeagueJoined {
  leagueSlug: string;
  userSlug: string;
  affiliate: boolean;
}

export interface ViewRivalsLeaguesGlobalLeaderboard {
  source: ViewRivalsLeaguesGlobalLeaderboard_Source;
}

export enum ViewRivalsLeaguesGlobalLeaderboard_Source {
  LEAGUES_LIST = 0,
  LEAGUE = 1,
  UNRECOGNIZED = -1,
}

export function viewRivalsLeaguesGlobalLeaderboard_SourceFromJSON(
  object: any
): ViewRivalsLeaguesGlobalLeaderboard_Source {
  switch (object) {
    case 0:
    case 'LEAGUES_LIST':
      return ViewRivalsLeaguesGlobalLeaderboard_Source.LEAGUES_LIST;
    case 1:
    case 'LEAGUE':
      return ViewRivalsLeaguesGlobalLeaderboard_Source.LEAGUE;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ViewRivalsLeaguesGlobalLeaderboard_Source.UNRECOGNIZED;
  }
}

export function viewRivalsLeaguesGlobalLeaderboard_SourceToJSON(
  object: ViewRivalsLeaguesGlobalLeaderboard_Source
): string {
  switch (object) {
    case ViewRivalsLeaguesGlobalLeaderboard_Source.LEAGUES_LIST:
      return 'LEAGUES_LIST';
    case ViewRivalsLeaguesGlobalLeaderboard_Source.LEAGUE:
      return 'LEAGUE';
    case ViewRivalsLeaguesGlobalLeaderboard_Source.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface SubmitJoinRivalsLeague {
  leagueSlug: string;
}

export interface ViewRivalsLeagueArenaBridgePopup {
  source: ViewRivalsLeagueArenaBridgePopup_Source;
}

export enum ViewRivalsLeagueArenaBridgePopup_Source {
  HEAD_TO_HEAD = 0,
  REWARD = 1,
  PROMOTION = 2,
  UNRECOGNIZED = -1,
}

export function viewRivalsLeagueArenaBridgePopup_SourceFromJSON(
  object: any
): ViewRivalsLeagueArenaBridgePopup_Source {
  switch (object) {
    case 0:
    case 'HEAD_TO_HEAD':
      return ViewRivalsLeagueArenaBridgePopup_Source.HEAD_TO_HEAD;
    case 1:
    case 'REWARD':
      return ViewRivalsLeagueArenaBridgePopup_Source.REWARD;
    case 2:
    case 'PROMOTION':
      return ViewRivalsLeagueArenaBridgePopup_Source.PROMOTION;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ViewRivalsLeagueArenaBridgePopup_Source.UNRECOGNIZED;
  }
}

export function viewRivalsLeagueArenaBridgePopup_SourceToJSON(
  object: ViewRivalsLeagueArenaBridgePopup_Source
): string {
  switch (object) {
    case ViewRivalsLeagueArenaBridgePopup_Source.HEAD_TO_HEAD:
      return 'HEAD_TO_HEAD';
    case ViewRivalsLeagueArenaBridgePopup_Source.REWARD:
      return 'REWARD';
    case ViewRivalsLeagueArenaBridgePopup_Source.PROMOTION:
      return 'PROMOTION';
    case ViewRivalsLeagueArenaBridgePopup_Source.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface EnterRivalsLeagueArenaBridge {
  source: EnterRivalsLeagueArenaBridge_Source;
}

export enum EnterRivalsLeagueArenaBridge_Source {
  HEAD_TO_HEAD = 0,
  REWARD = 1,
  PROMOTION = 2,
  UNRECOGNIZED = -1,
}

export function enterRivalsLeagueArenaBridge_SourceFromJSON(
  object: any
): EnterRivalsLeagueArenaBridge_Source {
  switch (object) {
    case 0:
    case 'HEAD_TO_HEAD':
      return EnterRivalsLeagueArenaBridge_Source.HEAD_TO_HEAD;
    case 1:
    case 'REWARD':
      return EnterRivalsLeagueArenaBridge_Source.REWARD;
    case 2:
    case 'PROMOTION':
      return EnterRivalsLeagueArenaBridge_Source.PROMOTION;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return EnterRivalsLeagueArenaBridge_Source.UNRECOGNIZED;
  }
}

export function enterRivalsLeagueArenaBridge_SourceToJSON(
  object: EnterRivalsLeagueArenaBridge_Source
): string {
  switch (object) {
    case EnterRivalsLeagueArenaBridge_Source.HEAD_TO_HEAD:
      return 'HEAD_TO_HEAD';
    case EnterRivalsLeagueArenaBridge_Source.REWARD:
      return 'REWARD';
    case EnterRivalsLeagueArenaBridge_Source.PROMOTION:
      return 'PROMOTION';
    case EnterRivalsLeagueArenaBridge_Source.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface EnterRivalsBridgeBanner {
  source: EnterRivalsBridgeBanner_Source;
}

export enum EnterRivalsBridgeBanner_Source {
  HEAD_TO_HEAD = 0,
  REWARD = 1,
  PROMOTION = 2,
  UNRECOGNIZED = -1,
}

export function enterRivalsBridgeBanner_SourceFromJSON(
  object: any
): EnterRivalsBridgeBanner_Source {
  switch (object) {
    case 0:
    case 'HEAD_TO_HEAD':
      return EnterRivalsBridgeBanner_Source.HEAD_TO_HEAD;
    case 1:
    case 'REWARD':
      return EnterRivalsBridgeBanner_Source.REWARD;
    case 2:
    case 'PROMOTION':
      return EnterRivalsBridgeBanner_Source.PROMOTION;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return EnterRivalsBridgeBanner_Source.UNRECOGNIZED;
  }
}

export function enterRivalsBridgeBanner_SourceToJSON(
  object: EnterRivalsBridgeBanner_Source
): string {
  switch (object) {
    case EnterRivalsBridgeBanner_Source.HEAD_TO_HEAD:
      return 'HEAD_TO_HEAD';
    case EnterRivalsBridgeBanner_Source.REWARD:
      return 'REWARD';
    case EnterRivalsBridgeBanner_Source.PROMOTION:
      return 'PROMOTION';
    case EnterRivalsBridgeBanner_Source.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface ViewComposeTeam {
  interactionContext: string;
  sport: Sport;
  so5LeaderboardSlug: string;
  so5LeaderboardRarity: string;
  so5LeaderboardSeasonality: string;
  so5LeagueName: string;
  so5FixtureSlug: string;
  composeSessionId: string;
  isOnboarding?: boolean | undefined;
}

export interface OpenPlayerDetails {
  interactionContext: string;
  sport: Sport;
  so5LeaderboardSlug: string;
  so5LeaderboardRarity: string;
  so5LeaderboardSeasonality: string;
  so5LeagueName: string;
  so5FixtureSlug: string;
  playerSlug: string;
  cardSlug: string;
  composeSessionId: string;
  isOnboarding?: boolean | undefined;
}

export interface SelectCard {
  benchObjectId: string;
  so5LeaderboardSlug: string;
  position: string;
  composeSessionId: string;
  interactionContext: string;
  sport: Sport;
  isOnboarding?: boolean | undefined;
}

export interface SelectCaptain {
  benchObjectId: string;
  so5LeaderboardSlug: string;
  position: string;
  composeSessionId: string;
  interactionContext: string;
  sport: Sport;
  isOnboarding?: boolean | undefined;
}

export interface ClickComposeClose {
  so5LeaderboardSlug: string;
  composeSessionId: string;
  interactionContext: string;
  sport: Sport;
  isOnboarding?: boolean | undefined;
}

export interface ClickConfirmLineup {
  so5LeaderboardSlug: string;
  composeSessionId: string;
  interactionContext: string;
  campaignSlug?: string | undefined;
  isLogged: boolean;
  hasWarnings: boolean;
  isOnboarding?: boolean | undefined;
  sport: Sport;
}

export interface ClickConfirmLineupAfterWarning {
  so5LeaderboardSlug: string;
  composeSessionId: string;
  interactionContext: string;
  campaignSlug?: string | undefined;
  isLogged: boolean;
  isOnboarding?: boolean | undefined;
  sport: Sport;
}

export interface ClickXpBalance {
  interactionContext: string;
  sport: Sport;
  rarity: string;
}

export interface ClickLineupBonus {
  interactionContext: string;
  sport: Sport;
  so5LineupId: string;
  rarity: string;
}

export interface ClickLevelUpCards {
  interactionContext: string;
  sport: Sport;
  cardSlugs: string[];
  rarity: string;
}

export interface ClickAddToCart {
  cartId: string;
  cardSlug: string;
  composeSessionId: string;
  ethAmount: number;
  eurAmount: number;
  interactionContext: string;
  offerId: string;
  scarcity: string;
  sport: Sport;
  origin: ClickAddToCart_Origin;
}

export enum ClickAddToCart_Origin {
  MARKETPLACE = 0,
  SCOUTING_CENTER = 1,
  COLLECTION = 2,
  CART_UPSELL = 3,
  CART_SAVED_FOR_LATER = 4,
  MATCH_VIEW = 5,
  CARD_PAGE = 6,
  MATCH_CENTER = 7,
  COMPOSE_TEAM = 8,
  TOP_PLAYERS = 9,
  MARKETPLACE_HOME = 10,
  UNRECOGNIZED = -1,
}

export function clickAddToCart_OriginFromJSON(
  object: any
): ClickAddToCart_Origin {
  switch (object) {
    case 0:
    case 'MARKETPLACE':
      return ClickAddToCart_Origin.MARKETPLACE;
    case 1:
    case 'SCOUTING_CENTER':
      return ClickAddToCart_Origin.SCOUTING_CENTER;
    case 2:
    case 'COLLECTION':
      return ClickAddToCart_Origin.COLLECTION;
    case 3:
    case 'CART_UPSELL':
      return ClickAddToCart_Origin.CART_UPSELL;
    case 4:
    case 'CART_SAVED_FOR_LATER':
      return ClickAddToCart_Origin.CART_SAVED_FOR_LATER;
    case 5:
    case 'MATCH_VIEW':
      return ClickAddToCart_Origin.MATCH_VIEW;
    case 6:
    case 'CARD_PAGE':
      return ClickAddToCart_Origin.CARD_PAGE;
    case 7:
    case 'MATCH_CENTER':
      return ClickAddToCart_Origin.MATCH_CENTER;
    case 8:
    case 'COMPOSE_TEAM':
      return ClickAddToCart_Origin.COMPOSE_TEAM;
    case 9:
    case 'TOP_PLAYERS':
      return ClickAddToCart_Origin.TOP_PLAYERS;
    case 10:
    case 'MARKETPLACE_HOME':
      return ClickAddToCart_Origin.MARKETPLACE_HOME;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ClickAddToCart_Origin.UNRECOGNIZED;
  }
}

export function clickAddToCart_OriginToJSON(
  object: ClickAddToCart_Origin
): string {
  switch (object) {
    case ClickAddToCart_Origin.MARKETPLACE:
      return 'MARKETPLACE';
    case ClickAddToCart_Origin.SCOUTING_CENTER:
      return 'SCOUTING_CENTER';
    case ClickAddToCart_Origin.COLLECTION:
      return 'COLLECTION';
    case ClickAddToCart_Origin.CART_UPSELL:
      return 'CART_UPSELL';
    case ClickAddToCart_Origin.CART_SAVED_FOR_LATER:
      return 'CART_SAVED_FOR_LATER';
    case ClickAddToCart_Origin.MATCH_VIEW:
      return 'MATCH_VIEW';
    case ClickAddToCart_Origin.CARD_PAGE:
      return 'CARD_PAGE';
    case ClickAddToCart_Origin.MATCH_CENTER:
      return 'MATCH_CENTER';
    case ClickAddToCart_Origin.COMPOSE_TEAM:
      return 'COMPOSE_TEAM';
    case ClickAddToCart_Origin.TOP_PLAYERS:
      return 'TOP_PLAYERS';
    case ClickAddToCart_Origin.MARKETPLACE_HOME:
      return 'MARKETPLACE_HOME';
    case ClickAddToCart_Origin.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface ClickSaveForLater {
  cartId: string;
  cardSlug: string;
  composeSessionId: string;
  ethAmount: number;
  eurAmount: number;
  interactionContext: string;
  offerId: string;
  scarcity: string;
  sport: Sport;
  origin: ClickSaveForLater_Origin;
}

export enum ClickSaveForLater_Origin {
  ADD_TO_CART_POPIN = 0,
  CART_MAIN = 1,
  CART_MAIN_REMOVED = 2,
  UNRECOGNIZED = -1,
}

export function clickSaveForLater_OriginFromJSON(
  object: any
): ClickSaveForLater_Origin {
  switch (object) {
    case 0:
    case 'ADD_TO_CART_POPIN':
      return ClickSaveForLater_Origin.ADD_TO_CART_POPIN;
    case 1:
    case 'CART_MAIN':
      return ClickSaveForLater_Origin.CART_MAIN;
    case 2:
    case 'CART_MAIN_REMOVED':
      return ClickSaveForLater_Origin.CART_MAIN_REMOVED;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ClickSaveForLater_Origin.UNRECOGNIZED;
  }
}

export function clickSaveForLater_OriginToJSON(
  object: ClickSaveForLater_Origin
): string {
  switch (object) {
    case ClickSaveForLater_Origin.ADD_TO_CART_POPIN:
      return 'ADD_TO_CART_POPIN';
    case ClickSaveForLater_Origin.CART_MAIN:
      return 'CART_MAIN';
    case ClickSaveForLater_Origin.CART_MAIN_REMOVED:
      return 'CART_MAIN_REMOVED';
    case ClickSaveForLater_Origin.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface ClickRemoveFromCart {
  cartId: string;
  cardSlug: string;
  composeSessionId: string;
  ethAmount: number;
  eurAmount: number;
  interactionContext: string;
  offerId: string;
  scarcity: string;
  sport: Sport;
  origin: ClickRemoveFromCart_Origin;
}

export enum ClickRemoveFromCart_Origin {
  ADD_TO_CART_POPIN = 0,
  CART_MAIN = 1,
  CART_MAIN_REMOVED = 2,
  CART_SAVED_FOR_LATER = 3,
  UNRECOGNIZED = -1,
}

export function clickRemoveFromCart_OriginFromJSON(
  object: any
): ClickRemoveFromCart_Origin {
  switch (object) {
    case 0:
    case 'ADD_TO_CART_POPIN':
      return ClickRemoveFromCart_Origin.ADD_TO_CART_POPIN;
    case 1:
    case 'CART_MAIN':
      return ClickRemoveFromCart_Origin.CART_MAIN;
    case 2:
    case 'CART_MAIN_REMOVED':
      return ClickRemoveFromCart_Origin.CART_MAIN_REMOVED;
    case 3:
    case 'CART_SAVED_FOR_LATER':
      return ClickRemoveFromCart_Origin.CART_SAVED_FOR_LATER;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ClickRemoveFromCart_Origin.UNRECOGNIZED;
  }
}

export function clickRemoveFromCart_OriginToJSON(
  object: ClickRemoveFromCart_Origin
): string {
  switch (object) {
    case ClickRemoveFromCart_Origin.ADD_TO_CART_POPIN:
      return 'ADD_TO_CART_POPIN';
    case ClickRemoveFromCart_Origin.CART_MAIN:
      return 'CART_MAIN';
    case ClickRemoveFromCart_Origin.CART_MAIN_REMOVED:
      return 'CART_MAIN_REMOVED';
    case ClickRemoveFromCart_Origin.CART_SAVED_FOR_LATER:
      return 'CART_SAVED_FOR_LATER';
    case ClickRemoveFromCart_Origin.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface MobileClickCheckoutIntermediateButton {
  cartId: string;
  ethAmount: number;
  eurAmount: number;
  interactionContext: string;
  sport: Sport;
}

export interface ClickLoanNotification {
  interactionContext: string;
  sport: Sport;
}

export interface ClickEnterLoanFlow {
  interactionContext: string;
  sport: Sport;
}

export interface ClickAddMultipleToCart {
  cartId: string;
  cardSlugs: string[];
  composeSessionId: string;
  ethAmount: number;
  eurAmount: number;
  interactionContext: string;
  offerIds: string[];
  scarcity: string;
  sport: Sport;
  collectionSlug: string;
  origin: ClickAddMultipleToCart_Origin;
  watchlistId?: string | undefined;
}

export enum ClickAddMultipleToCart_Origin {
  COMPLETE_COLLECTION = 0,
  NEXT_STEP_COLLECTION = 1,
  WATCHLIST = 2,
  UNRECOGNIZED = -1,
}

export function clickAddMultipleToCart_OriginFromJSON(
  object: any
): ClickAddMultipleToCart_Origin {
  switch (object) {
    case 0:
    case 'COMPLETE_COLLECTION':
      return ClickAddMultipleToCart_Origin.COMPLETE_COLLECTION;
    case 1:
    case 'NEXT_STEP_COLLECTION':
      return ClickAddMultipleToCart_Origin.NEXT_STEP_COLLECTION;
    case 2:
    case 'WATCHLIST':
      return ClickAddMultipleToCart_Origin.WATCHLIST;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ClickAddMultipleToCart_Origin.UNRECOGNIZED;
  }
}

export function clickAddMultipleToCart_OriginToJSON(
  object: ClickAddMultipleToCart_Origin
): string {
  switch (object) {
    case ClickAddMultipleToCart_Origin.COMPLETE_COLLECTION:
      return 'COMPLETE_COLLECTION';
    case ClickAddMultipleToCart_Origin.NEXT_STEP_COLLECTION:
      return 'NEXT_STEP_COLLECTION';
    case ClickAddMultipleToCart_Origin.WATCHLIST:
      return 'WATCHLIST';
    case ClickAddMultipleToCart_Origin.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface SuggestLineup {
  so5LeaderboardSlug: string;
  sport: Sport;
}

export interface ClickMarketHomeSection {
  origin: ClickMarketHomeSection_Section;
  playerSlug?: string | undefined;
  sport: Sport;
  scarcity: string;
  target: ClickMarketHomeSection_Target;
  cardSlug?: string | undefined;
  offerId?: string | undefined;
  ownerSlug?: string | undefined;
  watchlistSlug?: string | undefined;
  so5CompetitionSlug?: string | undefined;
  collectionSlug?: string | undefined;
}

export enum ClickMarketHomeSection_Section {
  BEST_PREDICTIONS = 0,
  TRENDING_AUCTIONS = 1,
  TOP_PERFORMERS = 2,
  FRIENDS_RECENT_PURCHASES = 3,
  WATCHLISTS = 4,
  COLLECTION = 5,
  TRENDING_PLAYERS = 6,
  UNRECOGNIZED = -1,
}

export function clickMarketHomeSection_SectionFromJSON(
  object: any
): ClickMarketHomeSection_Section {
  switch (object) {
    case 0:
    case 'BEST_PREDICTIONS':
      return ClickMarketHomeSection_Section.BEST_PREDICTIONS;
    case 1:
    case 'TRENDING_AUCTIONS':
      return ClickMarketHomeSection_Section.TRENDING_AUCTIONS;
    case 2:
    case 'TOP_PERFORMERS':
      return ClickMarketHomeSection_Section.TOP_PERFORMERS;
    case 3:
    case 'FRIENDS_RECENT_PURCHASES':
      return ClickMarketHomeSection_Section.FRIENDS_RECENT_PURCHASES;
    case 4:
    case 'WATCHLISTS':
      return ClickMarketHomeSection_Section.WATCHLISTS;
    case 5:
    case 'COLLECTION':
      return ClickMarketHomeSection_Section.COLLECTION;
    case 6:
    case 'TRENDING_PLAYERS':
      return ClickMarketHomeSection_Section.TRENDING_PLAYERS;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ClickMarketHomeSection_Section.UNRECOGNIZED;
  }
}

export function clickMarketHomeSection_SectionToJSON(
  object: ClickMarketHomeSection_Section
): string {
  switch (object) {
    case ClickMarketHomeSection_Section.BEST_PREDICTIONS:
      return 'BEST_PREDICTIONS';
    case ClickMarketHomeSection_Section.TRENDING_AUCTIONS:
      return 'TRENDING_AUCTIONS';
    case ClickMarketHomeSection_Section.TOP_PERFORMERS:
      return 'TOP_PERFORMERS';
    case ClickMarketHomeSection_Section.FRIENDS_RECENT_PURCHASES:
      return 'FRIENDS_RECENT_PURCHASES';
    case ClickMarketHomeSection_Section.WATCHLISTS:
      return 'WATCHLISTS';
    case ClickMarketHomeSection_Section.COLLECTION:
      return 'COLLECTION';
    case ClickMarketHomeSection_Section.TRENDING_PLAYERS:
      return 'TRENDING_PLAYERS';
    case ClickMarketHomeSection_Section.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export enum ClickMarketHomeSection_Target {
  PLAYER_DETAILS = 0,
  PLAYER_MARKET_DRAWER = 1,
  WATCHLIST = 2,
  PLAYER_PAGE = 3,
  USER_GALLERY = 4,
  ALL_BUTTON = 5,
  COLLECTION_PAGE = 6,
  UNRECOGNIZED = -1,
}

export function clickMarketHomeSection_TargetFromJSON(
  object: any
): ClickMarketHomeSection_Target {
  switch (object) {
    case 0:
    case 'PLAYER_DETAILS':
      return ClickMarketHomeSection_Target.PLAYER_DETAILS;
    case 1:
    case 'PLAYER_MARKET_DRAWER':
      return ClickMarketHomeSection_Target.PLAYER_MARKET_DRAWER;
    case 2:
    case 'WATCHLIST':
      return ClickMarketHomeSection_Target.WATCHLIST;
    case 3:
    case 'PLAYER_PAGE':
      return ClickMarketHomeSection_Target.PLAYER_PAGE;
    case 4:
    case 'USER_GALLERY':
      return ClickMarketHomeSection_Target.USER_GALLERY;
    case 5:
    case 'ALL_BUTTON':
      return ClickMarketHomeSection_Target.ALL_BUTTON;
    case 6:
    case 'COLLECTION_PAGE':
      return ClickMarketHomeSection_Target.COLLECTION_PAGE;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ClickMarketHomeSection_Target.UNRECOGNIZED;
  }
}

export function clickMarketHomeSection_TargetToJSON(
  object: ClickMarketHomeSection_Target
): string {
  switch (object) {
    case ClickMarketHomeSection_Target.PLAYER_DETAILS:
      return 'PLAYER_DETAILS';
    case ClickMarketHomeSection_Target.PLAYER_MARKET_DRAWER:
      return 'PLAYER_MARKET_DRAWER';
    case ClickMarketHomeSection_Target.WATCHLIST:
      return 'WATCHLIST';
    case ClickMarketHomeSection_Target.PLAYER_PAGE:
      return 'PLAYER_PAGE';
    case ClickMarketHomeSection_Target.USER_GALLERY:
      return 'USER_GALLERY';
    case ClickMarketHomeSection_Target.ALL_BUTTON:
      return 'ALL_BUTTON';
    case ClickMarketHomeSection_Target.COLLECTION_PAGE:
      return 'COLLECTION_PAGE';
    case ClickMarketHomeSection_Target.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface ClickMarketHoverMenuButton {
  target: ClickMarketHoverMenuButton_Target;
  sport: Sport;
}

export enum ClickMarketHoverMenuButton_Target {
  INSTANT_BUY = 0,
  AUCTIONS = 1,
  MANAGER_SALES = 2,
  UNRECOGNIZED = -1,
}

export function clickMarketHoverMenuButton_TargetFromJSON(
  object: any
): ClickMarketHoverMenuButton_Target {
  switch (object) {
    case 0:
    case 'INSTANT_BUY':
      return ClickMarketHoverMenuButton_Target.INSTANT_BUY;
    case 1:
    case 'AUCTIONS':
      return ClickMarketHoverMenuButton_Target.AUCTIONS;
    case 2:
    case 'MANAGER_SALES':
      return ClickMarketHoverMenuButton_Target.MANAGER_SALES;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ClickMarketHoverMenuButton_Target.UNRECOGNIZED;
  }
}

export function clickMarketHoverMenuButton_TargetToJSON(
  object: ClickMarketHoverMenuButton_Target
): string {
  switch (object) {
    case ClickMarketHoverMenuButton_Target.INSTANT_BUY:
      return 'INSTANT_BUY';
    case ClickMarketHoverMenuButton_Target.AUCTIONS:
      return 'AUCTIONS';
    case ClickMarketHoverMenuButton_Target.MANAGER_SALES:
      return 'MANAGER_SALES';
    case ClickMarketHoverMenuButton_Target.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface ClickBuyPack {
  packSlug: string;
  sport: Sport;
  currency: ClickBuyPack_Currency;
  amount: number;
  target: ClickBuyPack_Target;
  cardSetSlug: string;
}

export enum ClickBuyPack_Currency {
  GEM = 0,
  ESSENCE = 1,
  UNRECOGNIZED = -1,
}

export function clickBuyPack_CurrencyFromJSON(
  object: any
): ClickBuyPack_Currency {
  switch (object) {
    case 0:
    case 'GEM':
      return ClickBuyPack_Currency.GEM;
    case 1:
    case 'ESSENCE':
      return ClickBuyPack_Currency.ESSENCE;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ClickBuyPack_Currency.UNRECOGNIZED;
  }
}

export function clickBuyPack_CurrencyToJSON(
  object: ClickBuyPack_Currency
): string {
  switch (object) {
    case ClickBuyPack_Currency.GEM:
      return 'GEM';
    case ClickBuyPack_Currency.ESSENCE:
      return 'ESSENCE';
    case ClickBuyPack_Currency.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export enum ClickBuyPack_Target {
  BUY_GEMS_DIALOG = 0,
  CONFIRM = 1,
  UNRECOGNIZED = -1,
}

export function clickBuyPack_TargetFromJSON(object: any): ClickBuyPack_Target {
  switch (object) {
    case 0:
    case 'BUY_GEMS_DIALOG':
      return ClickBuyPack_Target.BUY_GEMS_DIALOG;
    case 1:
    case 'CONFIRM':
      return ClickBuyPack_Target.CONFIRM;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ClickBuyPack_Target.UNRECOGNIZED;
  }
}

export function clickBuyPack_TargetToJSON(object: ClickBuyPack_Target): string {
  switch (object) {
    case ClickBuyPack_Target.BUY_GEMS_DIALOG:
      return 'BUY_GEMS_DIALOG';
    case ClickBuyPack_Target.CONFIRM:
      return 'CONFIRM';
    case ClickBuyPack_Target.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface ClickGemPackage {
  eurAmount: number;
  gemAmount: number;
  purchasableItemId: string;
}

export interface OpenBuyGemsDialog {
  context: OpenBuyGemsDialog_Context;
  sport: Sport;
  packSlug?: string | undefined;
}

export enum OpenBuyGemsDialog_Context {
  GEMS_BALANCE = 0,
  /**
   * PACK_DIALOG - deprecated: this entry does not exist anymore
   * ===============================================
   */
  PACK_DIALOG = 1,
  /** INVENTORY - =============================================== */
  INVENTORY = 2,
  BUY_PACK_BUTTON = 3,
  BUY_GEMS_BUTTON_BLOCK = 4,
  UNRECOGNIZED = -1,
}

export function openBuyGemsDialog_ContextFromJSON(
  object: any
): OpenBuyGemsDialog_Context {
  switch (object) {
    case 0:
    case 'GEMS_BALANCE':
      return OpenBuyGemsDialog_Context.GEMS_BALANCE;
    case 1:
    case 'PACK_DIALOG':
      return OpenBuyGemsDialog_Context.PACK_DIALOG;
    case 2:
    case 'INVENTORY':
      return OpenBuyGemsDialog_Context.INVENTORY;
    case 3:
    case 'BUY_PACK_BUTTON':
      return OpenBuyGemsDialog_Context.BUY_PACK_BUTTON;
    case 4:
    case 'BUY_GEMS_BUTTON_BLOCK':
      return OpenBuyGemsDialog_Context.BUY_GEMS_BUTTON_BLOCK;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return OpenBuyGemsDialog_Context.UNRECOGNIZED;
  }
}

export function openBuyGemsDialog_ContextToJSON(
  object: OpenBuyGemsDialog_Context
): string {
  switch (object) {
    case OpenBuyGemsDialog_Context.GEMS_BALANCE:
      return 'GEMS_BALANCE';
    case OpenBuyGemsDialog_Context.PACK_DIALOG:
      return 'PACK_DIALOG';
    case OpenBuyGemsDialog_Context.INVENTORY:
      return 'INVENTORY';
    case OpenBuyGemsDialog_Context.BUY_PACK_BUTTON:
      return 'BUY_PACK_BUTTON';
    case OpenBuyGemsDialog_Context.BUY_GEMS_BUTTON_BLOCK:
      return 'BUY_GEMS_BUTTON_BLOCK';
    case OpenBuyGemsDialog_Context.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED';
  }
}

export interface ConfirmPurchaseForm {
  interactionContext: string;
  ethAmount: number;
  eurAmount: number;
  fiatPayment: boolean;
  sport: Sport;
  offerId: string;
  isV2?: boolean | undefined;
}

export const LoginUser: MessageFns<LoginUser> = {
  fromJSON(object: any): LoginUser {
    return {
      method: isSet(object.method)
        ? loginUser_MethodFromJSON(object.method)
        : 0,
      failed: isSet(object.failed) ? globalThis.Boolean(object.failed) : false,
    };
  },

  toJSON(message: LoginUser): unknown {
    const obj: any = {};
    if (message.method !== undefined) {
      obj.method = loginUser_MethodToJSON(message.method);
    }
    if (message.failed !== undefined) {
      obj.failed = message.failed;
    }
    return obj;
  },
};

export const LogoutUser: MessageFns<LogoutUser> = {
  fromJSON(_: any): LogoutUser {
    return {};
  },

  toJSON(_: LogoutUser): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ClickInstantBuy: MessageFns<ClickInstantBuy> = {
  fromJSON(object: any): ClickInstantBuy {
    return {
      offerId: isSet(object.offer_id) ? globalThis.String(object.offer_id) : '',
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      ethAmount: isSet(object.eth_amount)
        ? globalThis.Number(object.eth_amount)
        : undefined,
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      gameSlug: isSet(object.game_slug)
        ? globalThis.String(object.game_slug)
        : undefined,
      origin: isSet(object.origin)
        ? clickInstantBuy_FlowFromJSON(object.origin)
        : 0,
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : '',
      composeSessionId: isSet(object.compose_session_id)
        ? globalThis.String(object.compose_session_id)
        : '',
      rosterId: isSet(object.roster_id)
        ? globalThis.String(object.roster_id)
        : undefined,
    };
  },

  toJSON(message: ClickInstantBuy): unknown {
    const obj: any = {};
    if (message.offerId !== undefined) {
      obj.offer_id = message.offerId;
    }
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.ethAmount !== undefined) {
      obj.eth_amount = Math.round(message.ethAmount);
    }
    if (message.eurAmount !== undefined) {
      obj.eur_amount = Math.round(message.eurAmount);
    }
    if (message.gameSlug !== undefined) {
      obj.game_slug = message.gameSlug;
    }
    if (message.origin !== undefined) {
      obj.origin = clickInstantBuy_FlowToJSON(message.origin);
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.composeSessionId !== undefined) {
      obj.compose_session_id = message.composeSessionId;
    }
    if (message.rosterId !== undefined) {
      obj.roster_id = message.rosterId;
    }
    return obj;
  },
};

export const ClickBuyInAppPurchase: MessageFns<ClickBuyInAppPurchase> = {
  fromJSON(object: any): ClickBuyInAppPurchase {
    return {
      offerId: isSet(object.offer_id) ? globalThis.String(object.offer_id) : '',
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      ethAmount: isSet(object.eth_amount)
        ? globalThis.Number(object.eth_amount)
        : undefined,
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      gameSlug: isSet(object.game_slug)
        ? globalThis.String(object.game_slug)
        : undefined,
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickBuyInAppPurchase): unknown {
    const obj: any = {};
    if (message.offerId !== undefined) {
      obj.offer_id = message.offerId;
    }
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.ethAmount !== undefined) {
      obj.eth_amount = Math.round(message.ethAmount);
    }
    if (message.eurAmount !== undefined) {
      obj.eur_amount = Math.round(message.eurAmount);
    }
    if (message.gameSlug !== undefined) {
      obj.game_slug = message.gameSlug;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickBuyGemsPack: MessageFns<ClickBuyGemsPack> = {
  fromJSON(object: any): ClickBuyGemsPack {
    return {
      packId: isSet(object.pack_id) ? globalThis.String(object.pack_id) : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickBuyGemsPack): unknown {
    const obj: any = {};
    if (message.packId !== undefined) {
      obj.pack_id = message.packId;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickPreMatchUpsell: MessageFns<ClickPreMatchUpsell> = {
  fromJSON(object: any): ClickPreMatchUpsell {
    return {
      gameSlug: isSet(object.game_slug)
        ? globalThis.String(object.game_slug)
        : '',
      cardSlugs: globalThis.Array.isArray(object?.card_slugs)
        ? object.card_slugs.map((e: any) => globalThis.String(e))
        : [],
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickPreMatchUpsell): unknown {
    const obj: any = {};
    if (message.gameSlug !== undefined) {
      obj.game_slug = message.gameSlug;
    }
    if (message.cardSlugs?.length) {
      obj.card_slugs = message.cardSlugs;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickAfterPurchase: MessageFns<ClickAfterPurchase> = {
  fromJSON(object: any): ClickAfterPurchase {
    return {
      offerId: isSet(object.offer_id) ? globalThis.String(object.offer_id) : '',
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      gameSlug: isSet(object.game_slug)
        ? globalThis.String(object.game_slug)
        : undefined,
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      action: isSet(object.action)
        ? clickAfterPurchase_ActionFromJSON(object.action)
        : 0,
    };
  },

  toJSON(message: ClickAfterPurchase): unknown {
    const obj: any = {};
    if (message.offerId !== undefined) {
      obj.offer_id = message.offerId;
    }
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.gameSlug !== undefined) {
      obj.game_slug = message.gameSlug;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.action !== undefined) {
      obj.action = clickAfterPurchase_ActionToJSON(message.action);
    }
    return obj;
  },
};

export const ClickAfterLineupUpgradePurchase: MessageFns<ClickAfterLineupUpgradePurchase> =
  {
    fromJSON(object: any): ClickAfterLineupUpgradePurchase {
      return {
        gameSlug: isSet(object.game_slug)
          ? globalThis.String(object.game_slug)
          : '',
        lineupId: isSet(object.lineup_id)
          ? globalThis.String(object.lineup_id)
          : '',
        action: isSet(object.action)
          ? clickAfterLineupUpgradePurchase_ActionFromJSON(object.action)
          : 0,
        sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      };
    },

    toJSON(message: ClickAfterLineupUpgradePurchase): unknown {
      const obj: any = {};
      if (message.gameSlug !== undefined) {
        obj.game_slug = message.gameSlug;
      }
      if (message.lineupId !== undefined) {
        obj.lineup_id = message.lineupId;
      }
      if (message.action !== undefined) {
        obj.action = clickAfterLineupUpgradePurchase_ActionToJSON(
          message.action
        );
      }
      if (message.sport !== undefined) {
        obj.sport = sportToJSON(message.sport);
      }
      return obj;
    },
  };

export const ClickContinueWithoutUpgrade: MessageFns<ClickContinueWithoutUpgrade> =
  {
    fromJSON(object: any): ClickContinueWithoutUpgrade {
      return {
        gameSlug: isSet(object.game_slug)
          ? globalThis.String(object.game_slug)
          : '',
        lineupId: isSet(object.lineup_id)
          ? globalThis.String(object.lineup_id)
          : '',
        sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      };
    },

    toJSON(message: ClickContinueWithoutUpgrade): unknown {
      const obj: any = {};
      if (message.gameSlug !== undefined) {
        obj.game_slug = message.gameSlug;
      }
      if (message.lineupId !== undefined) {
        obj.lineup_id = message.lineupId;
      }
      if (message.sport !== undefined) {
        obj.sport = sportToJSON(message.sport);
      }
      return obj;
    },
  };

export const DisplayUpgradeLineup: MessageFns<DisplayUpgradeLineup> = {
  fromJSON(object: any): DisplayUpgradeLineup {
    return {
      gameSlug: isSet(object.game_slug)
        ? globalThis.String(object.game_slug)
        : '',
      lineupId: isSet(object.lineup_id)
        ? globalThis.String(object.lineup_id)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: DisplayUpgradeLineup): unknown {
    const obj: any = {};
    if (message.gameSlug !== undefined) {
      obj.game_slug = message.gameSlug;
    }
    if (message.lineupId !== undefined) {
      obj.lineup_id = message.lineupId;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickBoostRivalsLineup: MessageFns<ClickBoostRivalsLineup> = {
  fromJSON(object: any): ClickBoostRivalsLineup {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      gameSlug: isSet(object.game_slug)
        ? globalThis.String(object.game_slug)
        : '',
      lineupId: isSet(object.lineup_id)
        ? globalThis.String(object.lineup_id)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickBoostRivalsLineup): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.gameSlug !== undefined) {
      obj.game_slug = message.gameSlug;
    }
    if (message.lineupId !== undefined) {
      obj.lineup_id = message.lineupId;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const OpenRewardBox: MessageFns<OpenRewardBox> = {
  fromJSON(object: any): OpenRewardBox {
    return {
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      rewardBoxId: isSet(object.reward_box_id)
        ? globalThis.String(object.reward_box_id)
        : '',
    };
  },

  toJSON(message: OpenRewardBox): unknown {
    const obj: any = {};
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.rewardBoxId !== undefined) {
      obj.reward_box_id = message.rewardBoxId;
    }
    return obj;
  },
};

export const ViewRivalsLeaguesTutorial: MessageFns<ViewRivalsLeaguesTutorial> =
  {
    fromJSON(object: any): ViewRivalsLeaguesTutorial {
      return {
        step: isSet(object.step) ? globalThis.Number(object.step) : 0,
        source: isSet(object.source)
          ? viewRivalsLeaguesTutorial_SourceFromJSON(object.source)
          : 0,
      };
    },

    toJSON(message: ViewRivalsLeaguesTutorial): unknown {
      const obj: any = {};
      if (message.step !== undefined) {
        obj.step = Math.round(message.step);
      }
      if (message.source !== undefined) {
        obj.source = viewRivalsLeaguesTutorial_SourceToJSON(message.source);
      }
      return obj;
    },
  };

export const RivalsLeagueCreated: MessageFns<RivalsLeagueCreated> = {
  fromJSON(object: any): RivalsLeagueCreated {
    return { slug: isSet(object.slug) ? globalThis.String(object.slug) : '' };
  },

  toJSON(message: RivalsLeagueCreated): unknown {
    const obj: any = {};
    if (message.slug !== undefined) {
      obj.slug = message.slug;
    }
    return obj;
  },
};

export const RivalsLeagueJoined: MessageFns<RivalsLeagueJoined> = {
  fromJSON(object: any): RivalsLeagueJoined {
    return {
      leagueSlug: isSet(object.league_slug)
        ? globalThis.String(object.league_slug)
        : '',
      userSlug: isSet(object.user_slug)
        ? globalThis.String(object.user_slug)
        : '',
      affiliate: isSet(object.affiliate)
        ? globalThis.Boolean(object.affiliate)
        : false,
    };
  },

  toJSON(message: RivalsLeagueJoined): unknown {
    const obj: any = {};
    if (message.leagueSlug !== undefined) {
      obj.league_slug = message.leagueSlug;
    }
    if (message.userSlug !== undefined) {
      obj.user_slug = message.userSlug;
    }
    if (message.affiliate !== undefined) {
      obj.affiliate = message.affiliate;
    }
    return obj;
  },
};

export const ViewRivalsLeaguesGlobalLeaderboard: MessageFns<ViewRivalsLeaguesGlobalLeaderboard> =
  {
    fromJSON(object: any): ViewRivalsLeaguesGlobalLeaderboard {
      return {
        source: isSet(object.source)
          ? viewRivalsLeaguesGlobalLeaderboard_SourceFromJSON(object.source)
          : 0,
      };
    },

    toJSON(message: ViewRivalsLeaguesGlobalLeaderboard): unknown {
      const obj: any = {};
      if (message.source !== undefined) {
        obj.source = viewRivalsLeaguesGlobalLeaderboard_SourceToJSON(
          message.source
        );
      }
      return obj;
    },
  };

export const SubmitJoinRivalsLeague: MessageFns<SubmitJoinRivalsLeague> = {
  fromJSON(object: any): SubmitJoinRivalsLeague {
    return {
      leagueSlug: isSet(object.league_slug)
        ? globalThis.String(object.league_slug)
        : '',
    };
  },

  toJSON(message: SubmitJoinRivalsLeague): unknown {
    const obj: any = {};
    if (message.leagueSlug !== undefined) {
      obj.league_slug = message.leagueSlug;
    }
    return obj;
  },
};

export const ViewRivalsLeagueArenaBridgePopup: MessageFns<ViewRivalsLeagueArenaBridgePopup> =
  {
    fromJSON(object: any): ViewRivalsLeagueArenaBridgePopup {
      return {
        source: isSet(object.source)
          ? viewRivalsLeagueArenaBridgePopup_SourceFromJSON(object.source)
          : 0,
      };
    },

    toJSON(message: ViewRivalsLeagueArenaBridgePopup): unknown {
      const obj: any = {};
      if (message.source !== undefined) {
        obj.source = viewRivalsLeagueArenaBridgePopup_SourceToJSON(
          message.source
        );
      }
      return obj;
    },
  };

export const EnterRivalsLeagueArenaBridge: MessageFns<EnterRivalsLeagueArenaBridge> =
  {
    fromJSON(object: any): EnterRivalsLeagueArenaBridge {
      return {
        source: isSet(object.source)
          ? enterRivalsLeagueArenaBridge_SourceFromJSON(object.source)
          : 0,
      };
    },

    toJSON(message: EnterRivalsLeagueArenaBridge): unknown {
      const obj: any = {};
      if (message.source !== undefined) {
        obj.source = enterRivalsLeagueArenaBridge_SourceToJSON(message.source);
      }
      return obj;
    },
  };

export const EnterRivalsBridgeBanner: MessageFns<EnterRivalsBridgeBanner> = {
  fromJSON(object: any): EnterRivalsBridgeBanner {
    return {
      source: isSet(object.source)
        ? enterRivalsBridgeBanner_SourceFromJSON(object.source)
        : 0,
    };
  },

  toJSON(message: EnterRivalsBridgeBanner): unknown {
    const obj: any = {};
    if (message.source !== undefined) {
      obj.source = enterRivalsBridgeBanner_SourceToJSON(message.source);
    }
    return obj;
  },
};

export const ViewComposeTeam: MessageFns<ViewComposeTeam> = {
  fromJSON(object: any): ViewComposeTeam {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      so5LeaderboardSlug: isSet(object.so5_leaderboard_slug)
        ? globalThis.String(object.so5_leaderboard_slug)
        : '',
      so5LeaderboardRarity: isSet(object.so5_leaderboard_rarity)
        ? globalThis.String(object.so5_leaderboard_rarity)
        : '',
      so5LeaderboardSeasonality: isSet(object.so5_leaderboard_seasonality)
        ? globalThis.String(object.so5_leaderboard_seasonality)
        : '',
      so5LeagueName: isSet(object.so5_league_name)
        ? globalThis.String(object.so5_league_name)
        : '',
      so5FixtureSlug: isSet(object.so5_fixture_slug)
        ? globalThis.String(object.so5_fixture_slug)
        : '',
      composeSessionId: isSet(object.compose_session_id)
        ? globalThis.String(object.compose_session_id)
        : '',
      isOnboarding: isSet(object.is_onboarding)
        ? globalThis.Boolean(object.is_onboarding)
        : undefined,
    };
  },

  toJSON(message: ViewComposeTeam): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.so5LeaderboardSlug !== undefined) {
      obj.so5_leaderboard_slug = message.so5LeaderboardSlug;
    }
    if (message.so5LeaderboardRarity !== undefined) {
      obj.so5_leaderboard_rarity = message.so5LeaderboardRarity;
    }
    if (message.so5LeaderboardSeasonality !== undefined) {
      obj.so5_leaderboard_seasonality = message.so5LeaderboardSeasonality;
    }
    if (message.so5LeagueName !== undefined) {
      obj.so5_league_name = message.so5LeagueName;
    }
    if (message.so5FixtureSlug !== undefined) {
      obj.so5_fixture_slug = message.so5FixtureSlug;
    }
    if (message.composeSessionId !== undefined) {
      obj.compose_session_id = message.composeSessionId;
    }
    if (message.isOnboarding !== undefined) {
      obj.is_onboarding = message.isOnboarding;
    }
    return obj;
  },
};

export const OpenPlayerDetails: MessageFns<OpenPlayerDetails> = {
  fromJSON(object: any): OpenPlayerDetails {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      so5LeaderboardSlug: isSet(object.so5_leaderboard_slug)
        ? globalThis.String(object.so5_leaderboard_slug)
        : '',
      so5LeaderboardRarity: isSet(object.so5_leaderboard_rarity)
        ? globalThis.String(object.so5_leaderboard_rarity)
        : '',
      so5LeaderboardSeasonality: isSet(object.so5_leaderboard_seasonality)
        ? globalThis.String(object.so5_leaderboard_seasonality)
        : '',
      so5LeagueName: isSet(object.so5_league_name)
        ? globalThis.String(object.so5_league_name)
        : '',
      so5FixtureSlug: isSet(object.so5_fixture_slug)
        ? globalThis.String(object.so5_fixture_slug)
        : '',
      playerSlug: isSet(object.player_slug)
        ? globalThis.String(object.player_slug)
        : '',
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      composeSessionId: isSet(object.compose_session_id)
        ? globalThis.String(object.compose_session_id)
        : '',
      isOnboarding: isSet(object.is_onboarding)
        ? globalThis.Boolean(object.is_onboarding)
        : undefined,
    };
  },

  toJSON(message: OpenPlayerDetails): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.so5LeaderboardSlug !== undefined) {
      obj.so5_leaderboard_slug = message.so5LeaderboardSlug;
    }
    if (message.so5LeaderboardRarity !== undefined) {
      obj.so5_leaderboard_rarity = message.so5LeaderboardRarity;
    }
    if (message.so5LeaderboardSeasonality !== undefined) {
      obj.so5_leaderboard_seasonality = message.so5LeaderboardSeasonality;
    }
    if (message.so5LeagueName !== undefined) {
      obj.so5_league_name = message.so5LeagueName;
    }
    if (message.so5FixtureSlug !== undefined) {
      obj.so5_fixture_slug = message.so5FixtureSlug;
    }
    if (message.playerSlug !== undefined) {
      obj.player_slug = message.playerSlug;
    }
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.composeSessionId !== undefined) {
      obj.compose_session_id = message.composeSessionId;
    }
    if (message.isOnboarding !== undefined) {
      obj.is_onboarding = message.isOnboarding;
    }
    return obj;
  },
};

export const SelectCard: MessageFns<SelectCard> = {
  fromJSON(object: any): SelectCard {
    return {
      benchObjectId: isSet(object.bench_object_id)
        ? globalThis.String(object.bench_object_id)
        : '',
      so5LeaderboardSlug: isSet(object.so5_leaderboard_slug)
        ? globalThis.String(object.so5_leaderboard_slug)
        : '',
      position: isSet(object.position)
        ? globalThis.String(object.position)
        : '',
      composeSessionId: isSet(object.compose_session_id)
        ? globalThis.String(object.compose_session_id)
        : '',
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      isOnboarding: isSet(object.is_onboarding)
        ? globalThis.Boolean(object.is_onboarding)
        : undefined,
    };
  },

  toJSON(message: SelectCard): unknown {
    const obj: any = {};
    if (message.benchObjectId !== undefined) {
      obj.bench_object_id = message.benchObjectId;
    }
    if (message.so5LeaderboardSlug !== undefined) {
      obj.so5_leaderboard_slug = message.so5LeaderboardSlug;
    }
    if (message.position !== undefined) {
      obj.position = message.position;
    }
    if (message.composeSessionId !== undefined) {
      obj.compose_session_id = message.composeSessionId;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.isOnboarding !== undefined) {
      obj.is_onboarding = message.isOnboarding;
    }
    return obj;
  },
};

export const SelectCaptain: MessageFns<SelectCaptain> = {
  fromJSON(object: any): SelectCaptain {
    return {
      benchObjectId: isSet(object.bench_object_id)
        ? globalThis.String(object.bench_object_id)
        : '',
      so5LeaderboardSlug: isSet(object.so5_leaderboard_slug)
        ? globalThis.String(object.so5_leaderboard_slug)
        : '',
      position: isSet(object.position)
        ? globalThis.String(object.position)
        : '',
      composeSessionId: isSet(object.compose_session_id)
        ? globalThis.String(object.compose_session_id)
        : '',
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      isOnboarding: isSet(object.is_onboarding)
        ? globalThis.Boolean(object.is_onboarding)
        : undefined,
    };
  },

  toJSON(message: SelectCaptain): unknown {
    const obj: any = {};
    if (message.benchObjectId !== undefined) {
      obj.bench_object_id = message.benchObjectId;
    }
    if (message.so5LeaderboardSlug !== undefined) {
      obj.so5_leaderboard_slug = message.so5LeaderboardSlug;
    }
    if (message.position !== undefined) {
      obj.position = message.position;
    }
    if (message.composeSessionId !== undefined) {
      obj.compose_session_id = message.composeSessionId;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.isOnboarding !== undefined) {
      obj.is_onboarding = message.isOnboarding;
    }
    return obj;
  },
};

export const ClickComposeClose: MessageFns<ClickComposeClose> = {
  fromJSON(object: any): ClickComposeClose {
    return {
      so5LeaderboardSlug: isSet(object.so5_leaderboard_slug)
        ? globalThis.String(object.so5_leaderboard_slug)
        : '',
      composeSessionId: isSet(object.compose_session_id)
        ? globalThis.String(object.compose_session_id)
        : '',
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      isOnboarding: isSet(object.is_onboarding)
        ? globalThis.Boolean(object.is_onboarding)
        : undefined,
    };
  },

  toJSON(message: ClickComposeClose): unknown {
    const obj: any = {};
    if (message.so5LeaderboardSlug !== undefined) {
      obj.so5_leaderboard_slug = message.so5LeaderboardSlug;
    }
    if (message.composeSessionId !== undefined) {
      obj.compose_session_id = message.composeSessionId;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.isOnboarding !== undefined) {
      obj.is_onboarding = message.isOnboarding;
    }
    return obj;
  },
};

export const ClickConfirmLineup: MessageFns<ClickConfirmLineup> = {
  fromJSON(object: any): ClickConfirmLineup {
    return {
      so5LeaderboardSlug: isSet(object.so5_leaderboard_slug)
        ? globalThis.String(object.so5_leaderboard_slug)
        : '',
      composeSessionId: isSet(object.compose_session_id)
        ? globalThis.String(object.compose_session_id)
        : '',
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      campaignSlug: isSet(object.campaign_slug)
        ? globalThis.String(object.campaign_slug)
        : undefined,
      isLogged: isSet(object.is_logged)
        ? globalThis.Boolean(object.is_logged)
        : false,
      hasWarnings: isSet(object.has_warnings)
        ? globalThis.Boolean(object.has_warnings)
        : false,
      isOnboarding: isSet(object.is_onboarding)
        ? globalThis.Boolean(object.is_onboarding)
        : undefined,
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickConfirmLineup): unknown {
    const obj: any = {};
    if (message.so5LeaderboardSlug !== undefined) {
      obj.so5_leaderboard_slug = message.so5LeaderboardSlug;
    }
    if (message.composeSessionId !== undefined) {
      obj.compose_session_id = message.composeSessionId;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.campaignSlug !== undefined) {
      obj.campaign_slug = message.campaignSlug;
    }
    if (message.isLogged !== undefined) {
      obj.is_logged = message.isLogged;
    }
    if (message.hasWarnings !== undefined) {
      obj.has_warnings = message.hasWarnings;
    }
    if (message.isOnboarding !== undefined) {
      obj.is_onboarding = message.isOnboarding;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickConfirmLineupAfterWarning: MessageFns<ClickConfirmLineupAfterWarning> =
  {
    fromJSON(object: any): ClickConfirmLineupAfterWarning {
      return {
        so5LeaderboardSlug: isSet(object.so5_leaderboard_slug)
          ? globalThis.String(object.so5_leaderboard_slug)
          : '',
        composeSessionId: isSet(object.compose_session_id)
          ? globalThis.String(object.compose_session_id)
          : '',
        interactionContext: isSet(object.interaction_context)
          ? globalThis.String(object.interaction_context)
          : '',
        campaignSlug: isSet(object.campaign_slug)
          ? globalThis.String(object.campaign_slug)
          : undefined,
        isLogged: isSet(object.is_logged)
          ? globalThis.Boolean(object.is_logged)
          : false,
        isOnboarding: isSet(object.is_onboarding)
          ? globalThis.Boolean(object.is_onboarding)
          : undefined,
        sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      };
    },

    toJSON(message: ClickConfirmLineupAfterWarning): unknown {
      const obj: any = {};
      if (message.so5LeaderboardSlug !== undefined) {
        obj.so5_leaderboard_slug = message.so5LeaderboardSlug;
      }
      if (message.composeSessionId !== undefined) {
        obj.compose_session_id = message.composeSessionId;
      }
      if (message.interactionContext !== undefined) {
        obj.interaction_context = message.interactionContext;
      }
      if (message.campaignSlug !== undefined) {
        obj.campaign_slug = message.campaignSlug;
      }
      if (message.isLogged !== undefined) {
        obj.is_logged = message.isLogged;
      }
      if (message.isOnboarding !== undefined) {
        obj.is_onboarding = message.isOnboarding;
      }
      if (message.sport !== undefined) {
        obj.sport = sportToJSON(message.sport);
      }
      return obj;
    },
  };

export const ClickXpBalance: MessageFns<ClickXpBalance> = {
  fromJSON(object: any): ClickXpBalance {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      rarity: isSet(object.rarity) ? globalThis.String(object.rarity) : '',
    };
  },

  toJSON(message: ClickXpBalance): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.rarity !== undefined) {
      obj.rarity = message.rarity;
    }
    return obj;
  },
};

export const ClickLineupBonus: MessageFns<ClickLineupBonus> = {
  fromJSON(object: any): ClickLineupBonus {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      so5LineupId: isSet(object.so5_lineup_id)
        ? globalThis.String(object.so5_lineup_id)
        : '',
      rarity: isSet(object.rarity) ? globalThis.String(object.rarity) : '',
    };
  },

  toJSON(message: ClickLineupBonus): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.so5LineupId !== undefined) {
      obj.so5_lineup_id = message.so5LineupId;
    }
    if (message.rarity !== undefined) {
      obj.rarity = message.rarity;
    }
    return obj;
  },
};

export const ClickLevelUpCards: MessageFns<ClickLevelUpCards> = {
  fromJSON(object: any): ClickLevelUpCards {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      cardSlugs: globalThis.Array.isArray(object?.card_slugs)
        ? object.card_slugs.map((e: any) => globalThis.String(e))
        : [],
      rarity: isSet(object.rarity) ? globalThis.String(object.rarity) : '',
    };
  },

  toJSON(message: ClickLevelUpCards): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.cardSlugs?.length) {
      obj.card_slugs = message.cardSlugs;
    }
    if (message.rarity !== undefined) {
      obj.rarity = message.rarity;
    }
    return obj;
  },
};

export const ClickAddToCart: MessageFns<ClickAddToCart> = {
  fromJSON(object: any): ClickAddToCart {
    return {
      cartId: isSet(object.cart_id) ? globalThis.String(object.cart_id) : '',
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      composeSessionId: isSet(object.compose_session_id)
        ? globalThis.String(object.compose_session_id)
        : '',
      ethAmount: isSet(object.eth_amount)
        ? globalThis.Number(object.eth_amount)
        : 0,
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      offerId: isSet(object.offer_id) ? globalThis.String(object.offer_id) : '',
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      origin: isSet(object.origin)
        ? clickAddToCart_OriginFromJSON(object.origin)
        : 0,
    };
  },

  toJSON(message: ClickAddToCart): unknown {
    const obj: any = {};
    if (message.cartId !== undefined) {
      obj.cart_id = message.cartId;
    }
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.composeSessionId !== undefined) {
      obj.compose_session_id = message.composeSessionId;
    }
    if (message.ethAmount !== undefined) {
      obj.eth_amount = message.ethAmount;
    }
    if (message.eurAmount !== undefined) {
      obj.eur_amount = message.eurAmount;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.offerId !== undefined) {
      obj.offer_id = message.offerId;
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.origin !== undefined) {
      obj.origin = clickAddToCart_OriginToJSON(message.origin);
    }
    return obj;
  },
};

export const ClickSaveForLater: MessageFns<ClickSaveForLater> = {
  fromJSON(object: any): ClickSaveForLater {
    return {
      cartId: isSet(object.cart_id) ? globalThis.String(object.cart_id) : '',
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      composeSessionId: isSet(object.compose_session_id)
        ? globalThis.String(object.compose_session_id)
        : '',
      ethAmount: isSet(object.eth_amount)
        ? globalThis.Number(object.eth_amount)
        : 0,
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      offerId: isSet(object.offer_id) ? globalThis.String(object.offer_id) : '',
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      origin: isSet(object.origin)
        ? clickSaveForLater_OriginFromJSON(object.origin)
        : 0,
    };
  },

  toJSON(message: ClickSaveForLater): unknown {
    const obj: any = {};
    if (message.cartId !== undefined) {
      obj.cart_id = message.cartId;
    }
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.composeSessionId !== undefined) {
      obj.compose_session_id = message.composeSessionId;
    }
    if (message.ethAmount !== undefined) {
      obj.eth_amount = message.ethAmount;
    }
    if (message.eurAmount !== undefined) {
      obj.eur_amount = message.eurAmount;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.offerId !== undefined) {
      obj.offer_id = message.offerId;
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.origin !== undefined) {
      obj.origin = clickSaveForLater_OriginToJSON(message.origin);
    }
    return obj;
  },
};

export const ClickRemoveFromCart: MessageFns<ClickRemoveFromCart> = {
  fromJSON(object: any): ClickRemoveFromCart {
    return {
      cartId: isSet(object.cart_id) ? globalThis.String(object.cart_id) : '',
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : '',
      composeSessionId: isSet(object.compose_session_id)
        ? globalThis.String(object.compose_session_id)
        : '',
      ethAmount: isSet(object.eth_amount)
        ? globalThis.Number(object.eth_amount)
        : 0,
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      offerId: isSet(object.offer_id) ? globalThis.String(object.offer_id) : '',
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      origin: isSet(object.origin)
        ? clickRemoveFromCart_OriginFromJSON(object.origin)
        : 0,
    };
  },

  toJSON(message: ClickRemoveFromCart): unknown {
    const obj: any = {};
    if (message.cartId !== undefined) {
      obj.cart_id = message.cartId;
    }
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.composeSessionId !== undefined) {
      obj.compose_session_id = message.composeSessionId;
    }
    if (message.ethAmount !== undefined) {
      obj.eth_amount = message.ethAmount;
    }
    if (message.eurAmount !== undefined) {
      obj.eur_amount = message.eurAmount;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.offerId !== undefined) {
      obj.offer_id = message.offerId;
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.origin !== undefined) {
      obj.origin = clickRemoveFromCart_OriginToJSON(message.origin);
    }
    return obj;
  },
};

export const MobileClickCheckoutIntermediateButton: MessageFns<MobileClickCheckoutIntermediateButton> =
  {
    fromJSON(object: any): MobileClickCheckoutIntermediateButton {
      return {
        cartId: isSet(object.cart_id) ? globalThis.String(object.cart_id) : '',
        ethAmount: isSet(object.eth_amount)
          ? globalThis.Number(object.eth_amount)
          : 0,
        eurAmount: isSet(object.eur_amount)
          ? globalThis.Number(object.eur_amount)
          : 0,
        interactionContext: isSet(object.interaction_context)
          ? globalThis.String(object.interaction_context)
          : '',
        sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      };
    },

    toJSON(message: MobileClickCheckoutIntermediateButton): unknown {
      const obj: any = {};
      if (message.cartId !== undefined) {
        obj.cart_id = message.cartId;
      }
      if (message.ethAmount !== undefined) {
        obj.eth_amount = message.ethAmount;
      }
      if (message.eurAmount !== undefined) {
        obj.eur_amount = message.eurAmount;
      }
      if (message.interactionContext !== undefined) {
        obj.interaction_context = message.interactionContext;
      }
      if (message.sport !== undefined) {
        obj.sport = sportToJSON(message.sport);
      }
      return obj;
    },
  };

export const ClickLoanNotification: MessageFns<ClickLoanNotification> = {
  fromJSON(object: any): ClickLoanNotification {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickLoanNotification): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickEnterLoanFlow: MessageFns<ClickEnterLoanFlow> = {
  fromJSON(object: any): ClickEnterLoanFlow {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: ClickEnterLoanFlow): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickAddMultipleToCart: MessageFns<ClickAddMultipleToCart> = {
  fromJSON(object: any): ClickAddMultipleToCart {
    return {
      cartId: isSet(object.cart_id) ? globalThis.String(object.cart_id) : '',
      cardSlugs: globalThis.Array.isArray(object?.card_slugs)
        ? object.card_slugs.map((e: any) => globalThis.String(e))
        : [],
      composeSessionId: isSet(object.compose_session_id)
        ? globalThis.String(object.compose_session_id)
        : '',
      ethAmount: isSet(object.eth_amount)
        ? globalThis.Number(object.eth_amount)
        : 0,
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      offerIds: globalThis.Array.isArray(object?.offer_ids)
        ? object.offer_ids.map((e: any) => globalThis.String(e))
        : [],
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      collectionSlug: isSet(object.collection_slug)
        ? globalThis.String(object.collection_slug)
        : '',
      origin: isSet(object.origin)
        ? clickAddMultipleToCart_OriginFromJSON(object.origin)
        : 0,
      watchlistId: isSet(object.watchlist_id)
        ? globalThis.String(object.watchlist_id)
        : undefined,
    };
  },

  toJSON(message: ClickAddMultipleToCart): unknown {
    const obj: any = {};
    if (message.cartId !== undefined) {
      obj.cart_id = message.cartId;
    }
    if (message.cardSlugs?.length) {
      obj.card_slugs = message.cardSlugs;
    }
    if (message.composeSessionId !== undefined) {
      obj.compose_session_id = message.composeSessionId;
    }
    if (message.ethAmount !== undefined) {
      obj.eth_amount = message.ethAmount;
    }
    if (message.eurAmount !== undefined) {
      obj.eur_amount = message.eurAmount;
    }
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.offerIds?.length) {
      obj.offer_ids = message.offerIds;
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.collectionSlug !== undefined) {
      obj.collection_slug = message.collectionSlug;
    }
    if (message.origin !== undefined) {
      obj.origin = clickAddMultipleToCart_OriginToJSON(message.origin);
    }
    if (message.watchlistId !== undefined) {
      obj.watchlist_id = message.watchlistId;
    }
    return obj;
  },
};

export const SuggestLineup: MessageFns<SuggestLineup> = {
  fromJSON(object: any): SuggestLineup {
    return {
      so5LeaderboardSlug: isSet(object.so5_leaderboard_slug)
        ? globalThis.String(object.so5_leaderboard_slug)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
    };
  },

  toJSON(message: SuggestLineup): unknown {
    const obj: any = {};
    if (message.so5LeaderboardSlug !== undefined) {
      obj.so5_leaderboard_slug = message.so5LeaderboardSlug;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    return obj;
  },
};

export const ClickMarketHomeSection: MessageFns<ClickMarketHomeSection> = {
  fromJSON(object: any): ClickMarketHomeSection {
    return {
      origin: isSet(object.origin)
        ? clickMarketHomeSection_SectionFromJSON(object.origin)
        : 0,
      playerSlug: isSet(object.player_slug)
        ? globalThis.String(object.player_slug)
        : undefined,
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      scarcity: isSet(object.scarcity)
        ? globalThis.String(object.scarcity)
        : '',
      target: isSet(object.target)
        ? clickMarketHomeSection_TargetFromJSON(object.target)
        : 0,
      cardSlug: isSet(object.card_slug)
        ? globalThis.String(object.card_slug)
        : undefined,
      offerId: isSet(object.offer_id)
        ? globalThis.String(object.offer_id)
        : undefined,
      ownerSlug: isSet(object.owner_slug)
        ? globalThis.String(object.owner_slug)
        : undefined,
      watchlistSlug: isSet(object.watchlist_slug)
        ? globalThis.String(object.watchlist_slug)
        : undefined,
      so5CompetitionSlug: isSet(object.so5_competition_slug)
        ? globalThis.String(object.so5_competition_slug)
        : undefined,
      collectionSlug: isSet(object.collection_slug)
        ? globalThis.String(object.collection_slug)
        : undefined,
    };
  },

  toJSON(message: ClickMarketHomeSection): unknown {
    const obj: any = {};
    if (message.origin !== undefined) {
      obj.origin = clickMarketHomeSection_SectionToJSON(message.origin);
    }
    if (message.playerSlug !== undefined) {
      obj.player_slug = message.playerSlug;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.scarcity !== undefined) {
      obj.scarcity = message.scarcity;
    }
    if (message.target !== undefined) {
      obj.target = clickMarketHomeSection_TargetToJSON(message.target);
    }
    if (message.cardSlug !== undefined) {
      obj.card_slug = message.cardSlug;
    }
    if (message.offerId !== undefined) {
      obj.offer_id = message.offerId;
    }
    if (message.ownerSlug !== undefined) {
      obj.owner_slug = message.ownerSlug;
    }
    if (message.watchlistSlug !== undefined) {
      obj.watchlist_slug = message.watchlistSlug;
    }
    if (message.so5CompetitionSlug !== undefined) {
      obj.so5_competition_slug = message.so5CompetitionSlug;
    }
    if (message.collectionSlug !== undefined) {
      obj.collection_slug = message.collectionSlug;
    }
    return obj;
  },
};

export const ClickMarketHoverMenuButton: MessageFns<ClickMarketHoverMenuButton> =
  {
    fromJSON(object: any): ClickMarketHoverMenuButton {
      return {
        target: isSet(object.target)
          ? clickMarketHoverMenuButton_TargetFromJSON(object.target)
          : 0,
        sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      };
    },

    toJSON(message: ClickMarketHoverMenuButton): unknown {
      const obj: any = {};
      if (message.target !== undefined) {
        obj.target = clickMarketHoverMenuButton_TargetToJSON(message.target);
      }
      if (message.sport !== undefined) {
        obj.sport = sportToJSON(message.sport);
      }
      return obj;
    },
  };

export const ClickBuyPack: MessageFns<ClickBuyPack> = {
  fromJSON(object: any): ClickBuyPack {
    return {
      packSlug: isSet(object.pack_slug)
        ? globalThis.String(object.pack_slug)
        : '',
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      currency: isSet(object.currency)
        ? clickBuyPack_CurrencyFromJSON(object.currency)
        : 0,
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      target: isSet(object.target)
        ? clickBuyPack_TargetFromJSON(object.target)
        : 0,
      cardSetSlug: isSet(object.card_set_slug)
        ? globalThis.String(object.card_set_slug)
        : '',
    };
  },

  toJSON(message: ClickBuyPack): unknown {
    const obj: any = {};
    if (message.packSlug !== undefined) {
      obj.pack_slug = message.packSlug;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.currency !== undefined) {
      obj.currency = clickBuyPack_CurrencyToJSON(message.currency);
    }
    if (message.amount !== undefined) {
      obj.amount = Math.round(message.amount);
    }
    if (message.target !== undefined) {
      obj.target = clickBuyPack_TargetToJSON(message.target);
    }
    if (message.cardSetSlug !== undefined) {
      obj.card_set_slug = message.cardSetSlug;
    }
    return obj;
  },
};

export const ClickGemPackage: MessageFns<ClickGemPackage> = {
  fromJSON(object: any): ClickGemPackage {
    return {
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      gemAmount: isSet(object.gem_amount)
        ? globalThis.Number(object.gem_amount)
        : 0,
      purchasableItemId: isSet(object.purchasable_item_id)
        ? globalThis.String(object.purchasable_item_id)
        : '',
    };
  },

  toJSON(message: ClickGemPackage): unknown {
    const obj: any = {};
    if (message.eurAmount !== undefined) {
      obj.eur_amount = Math.round(message.eurAmount);
    }
    if (message.gemAmount !== undefined) {
      obj.gem_amount = Math.round(message.gemAmount);
    }
    if (message.purchasableItemId !== undefined) {
      obj.purchasable_item_id = message.purchasableItemId;
    }
    return obj;
  },
};

export const OpenBuyGemsDialog: MessageFns<OpenBuyGemsDialog> = {
  fromJSON(object: any): OpenBuyGemsDialog {
    return {
      context: isSet(object.context)
        ? openBuyGemsDialog_ContextFromJSON(object.context)
        : 0,
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      packSlug: isSet(object.pack_slug)
        ? globalThis.String(object.pack_slug)
        : undefined,
    };
  },

  toJSON(message: OpenBuyGemsDialog): unknown {
    const obj: any = {};
    if (message.context !== undefined) {
      obj.context = openBuyGemsDialog_ContextToJSON(message.context);
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.packSlug !== undefined) {
      obj.pack_slug = message.packSlug;
    }
    return obj;
  },
};

export const ConfirmPurchaseForm: MessageFns<ConfirmPurchaseForm> = {
  fromJSON(object: any): ConfirmPurchaseForm {
    return {
      interactionContext: isSet(object.interaction_context)
        ? globalThis.String(object.interaction_context)
        : '',
      ethAmount: isSet(object.eth_amount)
        ? globalThis.Number(object.eth_amount)
        : 0,
      eurAmount: isSet(object.eur_amount)
        ? globalThis.Number(object.eur_amount)
        : 0,
      fiatPayment: isSet(object.fiat_payment)
        ? globalThis.Boolean(object.fiat_payment)
        : false,
      sport: isSet(object.sport) ? sportFromJSON(object.sport) : 0,
      offerId: isSet(object.offer_id) ? globalThis.String(object.offer_id) : '',
      isV2: isSet(object.is_v2) ? globalThis.Boolean(object.is_v2) : undefined,
    };
  },

  toJSON(message: ConfirmPurchaseForm): unknown {
    const obj: any = {};
    if (message.interactionContext !== undefined) {
      obj.interaction_context = message.interactionContext;
    }
    if (message.ethAmount !== undefined) {
      obj.eth_amount = message.ethAmount;
    }
    if (message.eurAmount !== undefined) {
      obj.eur_amount = message.eurAmount;
    }
    if (message.fiatPayment !== undefined) {
      obj.fiat_payment = message.fiatPayment;
    }
    if (message.sport !== undefined) {
      obj.sport = sportToJSON(message.sport);
    }
    if (message.offerId !== undefined) {
      obj.offer_id = message.offerId;
    }
    if (message.isV2 !== undefined) {
      obj.is_v2 = message.isV2;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
